/* eslint-disable no-unused-vars */
import React, {Component} from "react";
import {InputLabel, withStyles, Select, MenuItem} from "@material-ui/core";
import classNames from 'classnames';
import FormControl from '@material-ui/core/FormControl';
import {API} from "../../../config";
import Util from "../../../yeffect/utils";

const country = API.service('country');

const styles = theme => ({
    input: {
        width: '100%',
    },
    wrapper:{
        paddingLeft:'8px',
        paddingRight:'8px'
    }
});

class CountrySelect extends Component {
    state = {
        active:     this.props.active || 1,
        countries:  false,
        options:    false,
    };

    updateOptions = () => {
        const app = this;

        let options = [];

        if(this.props.categoryValue === 'E'){

            if(this.props.groupValue === 'S'
                || this.props.groupValue === 'C'
                || this.props.groupValue === 'L'
            ) {
                options.push(
                    {value: 'T', label: 'T: Restrictions'},
                    {value: 'U', label: 'U: Free(Unrestricted)'},
                )
            }

            if(this.props.groupValue === 'P'
                || this.props.groupValue === 'F'
            ) {
                options.push(
                    {value: 'R', label: 'R: Redeemable'},
                    {value: 'E', label: 'E: Extendible'},
                    {value: 'T', label: 'T: Redeemable/Extendible'},
                    {value: 'G', label: 'G: Exchangeable'},
                    {value: 'A', label: 'A: Redeemable/Exchangeable/Extendible'},
                    {value: 'C', label: 'C: Redeemable/Exchangeable'},
                    {value: 'N', label: 'N: Perpetual'},
                )
            }

            if(this.props.groupValue === 'D') {
                options.push(
                    {value: 'R', label: 'R: Redeemable'},
                    {value: 'N', label: 'N: Perpetual'},
                    {value: 'B', label: 'B: Convertible'},
                    {value: 'D', label: 'D: Convertible/Redeemable'},
                    {value: 'X', label: 'X: Not Applicable/Undefined'},
                )
            }

            if(this.props.groupValue === 'Y') {
                options.push(
                    {value: 'R', label: 'D: Dividend Payments'},
                    {value: 'N', label: 'Y: No Payments'},
                    {value: 'B', label: 'M: Others(Miscellaneous)'},
                )
            }

            if(this.props.groupValue === 'M') {
                options.push(
                    {value: 'X', label: 'X: Not Applicable/Undefined'},
                )
            }
        }

        if(this.props.categoryValue === 'D'){

            if(this.props.groupValue === 'B'
                || this.props.groupValue === 'C'
                || this.props.groupValue === 'W'
                || this.props.groupValue === 'T'
                || this.props.groupValue === 'Y'
                || this.props.groupValue === 'G'
                || this.props.groupValue === 'A'
                || this.props.groupValue === 'N'
            ) {
                options.push(
                    {value: 'T', label: 'T: Government/State Guarantee'},
                    {value: 'G', label: 'G: Joint Guarantee'},
                    {value: 'S', label: 'S: Secured'},
                    {value: 'U', label: 'U: Unsecured/Unguaranteed'},
                    {value: 'P', label: 'P: Negative Pledge'},
                    {value: 'N', label: 'N: Senior'},
                    {value: 'O', label: 'O: Senior Subordinated'},
                    {value: 'Q', label: 'Q: Junior'},
                    {value: 'J', label: 'J: Junior Subordinated'},
                    {value: 'C', label: 'C: Supranational'},
                )
            }
            if(this.props.groupValue === 'S'
                || this.props.groupValue === 'E'
            ){
                options.push(
                    {value: 'F', label: 'F: Fixed Interest Payments'},
                    {value: 'D', label: 'D: Dividend Payments'},
                    {value: 'V', label: 'V: Variable Interest Payments'},
                    {value: 'Y', label: 'Y: No Payments'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},

                )
            }

            if(this.props.groupValue === 'D') {
                options.push(
                    {value: 'F', label: 'F: Fixed Rate'},
                    {value: 'Z', label: 'Z: Zero Rate/Discounted'},
                    {value: 'V', label: 'V: Variable'},
                    {value: 'C', label: 'C: Cash Payment'},
                )
            }

            if(this.props.groupValue === 'M') {
                options.push(
                    {value: 'X', label: 'X: Not Applicable/Undefined'},
                )
            }
        }

        if(this.props.categoryValue === 'C') {

            if (this.props.groupValue === 'H'
                || this.props.groupValue === 'M'
            ) {
                if (this.props.lvl1Value !== ''

                ) {
                    options.push(
                        {value: 'X', label: 'X: Not Applicable / Undefined'},
                    )
                }
            }

            if (this.props.groupValue === 'B'
                || this.props.groupValue === 'E'
                || this.props.groupValue === 'F'
                || this.props.groupValue === 'P'
                || this.props.groupValue === 'I'
            ) {
                if (this.props.lvl1Value !== ''

                ) {
                    options.push(
                        {value: 'I', label: 'I: Income Funds'},
                        {value: 'G', label: 'G: Accumulation Funds'},
                        {value: 'J', label: 'J: Mixed Funds'},
                    )
                }
            }

            if (this.props.groupValue === 'S') {
                if (this.props.lvl1Value !== ''

                ) {
                    options.push(
                        {value: 'B', label: 'B: Balanced/Conservative'},
                        {value: 'G', label: 'G: Growth'},
                        {value: 'L', label: 'L: Life Style'},
                        {value: 'M', label: 'M: Others'},
                    )
                }
            }
        }

        if(this.props.categoryValue === 'R') {

            if (this.props.groupValue === 'A'
                || this.props.groupValue === 'S'
                || this.props.groupValue === 'S'
                || this.props.groupValue === 'P'
                || this.props.groupValue === 'D'
                || this.props.groupValue === 'M'
            ) {
                if (this.props.lvl1Value    !== ''

                ) {
                    options.push(
                        {value:'X',label:'X: Not Applicable / Undefined'},
                    )
                }
            }

            if (this.props.groupValue === 'W') {
                if (this.props.lvl1Value    !== ''

                ) {
                    options.push(
                        {value:'T',label:'T: Traditional Warrants'},
                        {value:'N',label:'N: Naked Warrants'},
                        {value:'C',label:'C: Covered Warrants'},
                    )
                }
            }

            if (this.props.groupValue === 'F') {
                if (this.props.lvl1Value    !== ''

                ) {
                    options.push(
                        {value:'T',label:'T: Barrier Underlying Based'},
                        {value:'N',label:'N: Barrier Instrument Based'},
                        {value:'M',label:'M: Others(Miscellaneous)'},
                    )
                }
            }
        }

        if(this.props.categoryValue === 'O') {

            if (this.props.groupValue === 'M') {
                if (this.props.lvl1Value    !== ''

                ) {
                    options.push(
                        {value:'X',label:'X: Not Applicable / Undefined'},
                    )
                }
            }

            if (this.props.groupValue === 'C'
                || this.props.groupValue === 'P') {
                if (this.props.lvl1Value    !== ''

                ) {
                    options.push(
                        {value:'B',label:'B: Baskets'},
                        {value:'S',label:'S: Stock-Equities'},
                        {value:'D',label:'D: Debt Instruments'},
                        {value:'T',label:'T: Commodities'},
                        {value:'C',label:'C: Currencies'},
                        {value:'I',label:'I: Indices'},
                        {value:'O',label:'O: Options'},
                        {value:'F',label:'F: Futures'},
                        {value:'W',label:'W: Swaps'},
                        {value:'N',label:'N: Interest Rates'},
                        {value:'M',label:'M: Others(Miscellaneous)'},
                    )
                }
            }
        }

        if(this.props.categoryValue === 'F') {

            if (this.props.groupValue !== '') {
                if (this.props.lvl1Value    !== ''

                ) {
                    options.push(
                        {value:'P',label:'P: Physical'},
                        {value:'C',label:'C: Cash'},
                        {value:'N',label:'N: Non-Deliverable'},
                    )
                }
            }
        }

        if(this.props.categoryValue === 'T') {

            if (this.props.groupValue === 'C'
                || this.props.groupValue === 'T'
                || this.props.groupValue === 'B'
                || this.props.groupValue === 'D'
                || this.props.groupValue === 'M'
            ) {
                if (this.props.lvl1Value    !== ''

                ) {
                    options.push(
                        {value:'X',label:'X: Not Applicable / Undefined'},
                    )
                }
            }

            if (this.props.groupValue === 'R') {
                if (this.props.lvl1Value    !== ''

                ) {
                    options.push(
                        {value:'D',label:'D: Daily'},
                        {value:'W',label:'W: Weekly'},
                        {value:'M',label:'M: Monthly'},
                        {value:'Q',label:'Q: Quarterly'},
                        {value:'S',label:'S: Semi-Annually'},
                        {value:'A',label:'A: Annually'},
                        {value:'M',label:'M: Others(Miscellaneous)'},
                    )
                }
            }

            if (this.props.groupValue === 'I') {
                if (this.props.lvl1Value    !== ''

                ) {
                    options.push(
                        {value:'P',label:'P: Price Weighted'},
                        {value:'C',label:'C: Capitalization Weighted'},
                        {value:'E',label:'E: Equal Weighted'},
                        {value:'F',label:'F: Modified Market Capitalization Weighted'},
                        {value:'M',label:'M: Others(Miscellaneous)'},
                    )
                }
            }
        }

        if(this.props.categoryValue === 'M') {

            if (this.props.groupValue === 'M') {
                if (this.props.lvl1Value    !== ''

                ) {
                    options.push(
                        {value:'X',label:'X: Not Applicable / Undefined'},
                    )
                }
            }

            if (this.props.groupValue === 'C') {
                if (this.props.lvl1Value    !== ''

                ) {
                    options.push(
                        {value:'T',label:'T: Restriction'},
                        {value:'U',label:'U: Free(Unrestricted)'},
                    )
                }
            }
        }

        app.setState({
            options: options
        })
    }

    componentDidMount() {
        this.updateOptions();
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if(this.props.categoryValue !== prevProps.categoryValue || this.props.groupValue !== prevProps.groupValue){
            this.updateOptions();
        }
    }

    render() {
        const { classes, possibleValues, value, width, onChange, fieldLabel, fieldName, errorFields, categoryValue} = this.props;
        const { active } = this.state;

        return (
            <React.Fragment>
                <div className={classNames(classes.wrapper,width)}>

                    <FormControl className={classNames('w-full')} >
                        <InputLabel id={fieldName + '_label'} shrink={(!Util.isEmpty(value) || value === false)}>{fieldLabel} {(this.props.required === true) ? '*' :''}</InputLabel>
                        <Select
                            labelId={fieldName + '_label'}
                            id={fieldName}
                            value={value}
                            label="Age"
                            name={fieldName}
                            onChange={onChange}
                            error={!(typeof errorFields[fieldName] === "undefined")}
                            helperText={(typeof errorFields[fieldName] !== "undefined") ? errorFields[fieldName] : false}
                            required={this.props.required}
                            >


                            <option value=""> </option>
                            {(this.state.options !== false) &&
                            this.state.options.map(o => {
                                return (
                                    <MenuItem value={o.value}>{o.label}</MenuItem>
                                )

                            })
                            }
                        </Select>
                    </FormControl>

                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(CountrySelect);



// WEBPACK FOOTER //
// ./src/yeffect/formBuilder/components/CFILevel2Select.js